function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Chart(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 2a1 1 0 011 1v17.55h18.895a1 1 0 010 2H2a1 1 0 01-1-1V3a1 1 0 011-1zm19.895 4.102h.033l.057.004-.09-.004a1.006 1.006 0 01.625.22l.082.073a1.007 1.007 0 01.007.008l.016.017c.021.022.041.046.06.07l-.076-.087a1.004 1.004 0 01.172.235l.02.042.03.068.01.03c.01.027.017.053.024.079l.009.04a.825.825 0 01.02.182v3.77a1 1 0 01-2 0V9.48l-5.538 5.425a1 1 0 01-1.413-.013l-2.94-2.99L5.7 17.149a.996.996 0 01-1.414-.006 1 1 0 01.006-1.414l6.015-5.954c.19-.187.46-.284.71-.29.266.002.52.11.706.299l2.945 2.994 4.774-4.676h-1.295a1 1 0 010-2h3.747z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoChart = /*#__PURE__*/React.memo(Chart);
export default MemoChart;